import { ICancellablePromise } from './../../../types/cancellable-promise';
import { ProjectConfig } from './../../../types/project-config';
import { ServerService } from 'app/model/services/api-services/server.service';
import { Injectable } from '@angular/core';
import { ConfigOptions } from 'app/model/project-config-util';

@Injectable({
  providedIn: 'root'
})
export class ProjectConfigService {

  constructor(private server:ServerService) { }
  SaveConfig(config:ConfigOptions):ICancellablePromise {
    return this.server.Post('project/config/save',config);
  }

}
